(() => {
  if (window.__dlFunnelTrackingV2) return;
  window.__dlFunnelTrackingV2 = true;
  const config = document.getElementById('droplit-analytics-config');
  if (!config || config.dataset.enabled !== 'true') return;
  const themeId = config.dataset.themeId;
  const query = new URLSearchParams(location.search);
  const environment = query.has('preview_theme_id') || window.Shopify?.designMode ? 'testing' : config.dataset.environment || 'testing';
  const flow = () => document.querySelector('[data-credit-cart],[data-credit-designer]') ? 'custom_drop_credit' : document.querySelector('[data-pets-bonus-offer="true"]') ? 'pets_b_bonus_bundle' : config.dataset.pageKey === 'custom-drop-credit' ? 'custom_drop_credit' : config.dataset.pageKey === 'ut-quick-bundle' || config.dataset.pageKey === 'quick-bundle' ? 'ut_quick_bundle' : document.querySelector('[data-stormy-pack]') ? 'stormy_rain_bundle' : document.querySelector('[data-landing-skin]')?.dataset.landingSkin === 'halloween' ? 'halloween_bundle' : document.querySelector('[data-landing-skin]')?.dataset.landingSkin === 'pets' ? 'pets_bundle' : document.querySelector('[data-mike-page]') ? 'mike_bundle' : document.querySelector('[data-standalone]')?.dataset.mode === 'hat' ? 'hat_only' : document.querySelector('[data-standalone]') ? 'drop_only' : location.pathname.includes('/cart') ? 'cart' : document.querySelector('.dl') ? 'custom_bundle' : 'storefront';
  const debug = new URLSearchParams(location.search).get('dl_analytics_debug') === '1';
  const history = [], once = new Set(), roots = new WeakSet(), saved = new WeakMap();
  const key = `droplit_analytics_v2_${themeId}`;
  let attribution, clarityLoaded = false, pending = [];
  const names = new Set('scroll_depth section_viewed emblem_selected quantity_changed video_started video_completed landing_view create_bundle_clicked builder_reached hat_selected drop_started image_uploaded library_image_selected upload_started upload_error crop_opened crop_completed crop_error background_remove_started background_remove_completed background_remove_error drop_saved save_drop_clicked save_drop_error bundle_completed permission_confirmed permission_unchecked add_to_cart_clicked add_to_cart_blocked add_to_cart_success add_to_cart_error checkout_clicked navigation_clicked library_filter_clicked design_selected cart_viewed frame_opened frame_selected frame_applied popup_viewed popup_dismissed signup_submitted signup_success signup_error'.split(' '));
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  function context() {
    if (attribution) return attribution;
    const q = new URLSearchParams(location.search);
    let previous = {};
    try { previous = JSON.parse(sessionStorage.getItem(key) || '{}'); } catch (_) {}
    const clean = value => /^[a-zA-Z0-9_. -]{1,100}$/.test(value || '') ? value : '';
    const fresh = q.has('utm_source'), result = {};
    for (const field of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']) result[field] = clean(q.get(field) || (!fresh && previous[field]) || '');
    let host = '';
    try { host = new URL(document.referrer).hostname; } catch (_) {}
    result.channel = /instagram|facebook|meta|^ig$|^fb$/i.test(result.utm_source) || /(^|\.)(instagram|facebook)\.com$/.test(host)
      ? 'meta' : result.utm_source ? 'campaign' : host && host !== location.hostname ? 'referral' : previous.channel || 'direct';
    try { sessionStorage.setItem(key, JSON.stringify(result)); } catch (_) {}
    return attribution = result;
  }
  function mask() {
    document.querySelectorAll('.dl .drop,.dl .slotthumb,.dl .summary,.dl [data-host],.dl-fc,.dl-crop-overlay,[data-selected-art],[data-hat-drop],[data-upload-name],[data-design-name],[data-editor-one]').forEach(el => el.setAttribute('data-clarity-mask', 'true'));
  }
  function clarityConsent() {
    if (clarityLoaded) window.clarity('consentv2', { analytics_Storage: allowed() ? 'granted' : 'denied', ad_Storage: 'denied' });
  }
  function startClarity() {
    const id = config.dataset.clarityId || '';
    if (!allowed() || clarityLoaded || !/^[a-z0-9]{5,30}$/i.test(id)) return;
    mask();
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    clarityLoaded = true;
    clarityConsent();
    window.clarity('set', 'droplit_environment', environment);
    window.clarity('set', 'droplit_theme_id', themeId);
    window.clarity('set', 'droplit_flow', flow());
    for (const field of ['pageId','pageKey','pageType','template']) {
      const value = config.dataset[field];
      if (/^[a-zA-Z0-9_.-]{1,100}$/.test(value || '')) window.clarity('set', 'droplit_' + field, value);
    }
    for (const [field, value] of Object.entries(context())) if (value) window.clarity('set', field, value);
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${id}`;
    if (!document.querySelector('script[src*="clarity.ms/tag/"]')) document.head.appendChild(script);
  }
  function publish(entry) {
    const api = window.Shopify?.analytics;
    if (!api?.publish) return false;
    try {
      const result = api.publish(`droplit:${entry.name}`, entry.data);
      if (result?.catch) result.catch(() => {});
      return true;
    } catch (_) { return false; }
  }
  function track(name, detail = {}) {
    try {
      name = name.replace(/^droplit:/, '');
      if (!names.has(name)) return;
      if (name === 'upload_started' || name === 'library_image_selected') trackOnce('drop_started', { slot: detail.slot }, String(detail.slot));
      const data = { theme_id: themeId, environment, schema_version: 4, flow: flow() };
      for (const [field, value] of Object.entries({ page_id: config.dataset.pageId, page_key: config.dataset.pageKey, page_type: config.dataset.pageType })) {
        if (/^[a-zA-Z0-9_.-]{1,100}$/.test(value || '')) data[field] = value;
      }
      if (Number.isInteger(detail.slot) && detail.slot >= 1 && detail.slot <= 4) data.slot = detail.slot;
      for (const field of ['reason', 'hat', 'action', 'frame', 'section', 'emblem']) if (/^[a-z0-9_ -]{1,40}$/i.test(detail[field] || '')) data[field] = detail[field];
      if (/^[a-z0-9_ -]{1,40}$/i.test(detail.source || '')) data.design_source = detail.source;
      if (/^[a-zA-Z0-9_-]{1,100}$/.test(detail.section_id || '')) data.section_id = detail.section_id;
      if (/^[a-zA-Z0-9_.-]{1,100}$/.test(config.dataset.template || '')) data.layout_variant = config.dataset.template;
      for (const field of ['quantity','percent']) if (Number.isInteger(detail[field]) && detail[field] >= 0 && detail[field] <= 100) data[field] = detail[field];
      if (Number.isInteger(detail.status)) data.status = detail.status;
      if (allowed()) Object.assign(data, context());
      if (debug) {
        history.push({ name, data, consent: allowed(), time: new Date().toISOString() });
        if (history.length > 200) history.shift();
      }
      if (!allowed()) return;
      startClarity();
      if (clarityLoaded) {
        window.clarity('event', `dl_${name}`);
        if (name === 'drop_saved' || name === 'drop_started') window.clarity('event', `dl_drop_${data.slot}_${name === 'drop_saved' ? 'saved' : 'started'}`);
      }
      const entry = { name, data };
      if (!publish(entry)) { pending.push(entry); if (pending.length > 30) pending.shift(); }
    } catch (_) {}
  }
  window.DroplitFunnel = { track, history, status: () => ({ environment, themeId, consent: allowed(), clarityConfigured: Boolean(config.dataset.clarityId), clarityLoaded, pending: pending.length }) };
  function trackOnce(name, detail = {}, suffix = '') {
    const id = `${name}:${suffix}`;
    if (once.has(id)) return;
    if (allowed()) once.add(id);
    track(name, detail);
  }
  function wire(root) {
    if (roots.has(root)) return;
    roots.add(root);
    const state = new Map();
    saved.set(root, state);
    root.addEventListener('droplit:drop-saved', event => {
      const slot = Number(event.detail?.slot), image = root.__dlSlots?.[slot - 1];
      if (!image || root.dataset[`dlSaved${slot}`] !== '1' || state.get(slot) === image) return;
      state.set(slot, image);
      track('drop_saved', { slot });
      if (root.dataset.dlSaved1 === '1' && (root.dataset.petsBonusOffer === 'true' || root.dataset.dlSaved2 === '1')) trackOnce('bundle_completed', {}, root.id);
    });
    root.addEventListener('change', event => {
      if (event.target.matches('[data-variants]')) track('hat_selected', { hat: root.dataset.hat });
      if (event.target.matches('[data-rights]')) track(event.target.checked ? 'permission_confirmed' : 'permission_unchecked');
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) trackOnce('builder_reached', {}, root.id);
      }, { threshold: 0.25 });
      observer.observe(root.querySelector('.stageviewport') || root);
    }
  }
  const campaignRoots = new WeakSet();
  function wireCampaign(root) {
    if (campaignRoots.has(root)) return;
    campaignRoots.add(root);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || !allowed()) return;
          const section = Array.from(entry.target.classList).find(c => c.startsWith('sr-block-'))?.slice(9);
          if (section) trackOnce('section_viewed', { section }, section);
        });
      }, { threshold: 0.25 });
      root.querySelectorAll('.sr-block').forEach(el => observer.observe(el));
      document.addEventListener('visitorConsentCollected', () => {
        root.querySelectorAll('.sr-block').forEach(el => { observer.unobserve(el); observer.observe(el); });
      });
    }
    root.querySelectorAll('video').forEach(video => {
      video.addEventListener('play', () => trackOnce('video_started'));
      video.addEventListener('ended', () => trackOnce('video_completed'));
    });
  }
  const observedSections = new WeakSet();
  let sectionObserver;
  function wireSections() {
    if (!('IntersectionObserver' in window)) return;
    sectionObserver ||= new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting || !allowed()) continue;
        const el = entry.target;
        const id = el.dataset.analyticsSection || el.id.replace(/^shopify-section-/, '');
        const label = el.dataset.analyticsSection || id.split('__').pop();
        trackOnce('section_viewed', { section: label, section_id: id }, id);
      }
    }, { threshold: 0 });
    document.querySelectorAll('main .shopify-section,main [data-analytics-section]').forEach(el => {
      // Stormy Rain already emits the named block-level events used in its report.
      if (el.querySelector('[data-stormy-pack]') || el.closest('[data-stormy-pack]')) return;
      if (!observedSections.has(el)) { observedSections.add(el); sectionObserver.observe(el); }
    });
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (sectionObserver) document.querySelectorAll('main .shopify-section,main [data-analytics-section]').forEach(el => {
      if (observedSections.has(el)) { sectionObserver.unobserve(el); sectionObserver.observe(el); }
    });
  });
  let scrollScheduled = false;
  function measureScroll() {
    scrollScheduled = false;
    if (!allowed()) return;
    const height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    const percent = Math.min(100, Math.floor((window.scrollY + window.innerHeight) / height * 100));
    for (const milestone of [25,50,75,90,100]) if (percent >= milestone) trackOnce('scroll_depth', { percent: milestone }, String(milestone));
  }
  window.addEventListener('scroll', () => {
    if (!scrollScheduled) { scrollScheduled = true; requestAnimationFrame(measureScroll); }
  }, { passive: true });
  window.addEventListener('resize', measureScroll);
  function boot() {
    wireSections();
    document.querySelectorAll('[data-stormy-pack]').forEach(wireCampaign);
    measureScroll();
    mask();
    document.querySelectorAll('.dl').forEach(wire);
    if (allowed()) { startClarity(); trackOnce('landing_view'); if (flow() === 'cart') trackOnce('cart_viewed'); }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button,a,input[name="checkout"]');
    if (!button || button.disabled) return;
    if (button.matches('[data-library-filter]')) track('library_filter_clicked', { action: 'library_filter' });
    if (button.matches('a[href]')) {
      try {
        const url = new URL(button.getAttribute('href'), location.origin), view = url.searchParams.get('view');
        const action = (view === 'mike-mcintire' || /\/pages\/mike-mcintire\/?$/.test(url.pathname)) ? 'shop_mike' : view === 'single-drop' ? 'shop_drops' : view === 'hat-only' ? 'shop_hats' : url.pathname === '/cart' ? 'open_cart' : '';
        if (action) track('navigation_clicked', { action });
      } catch (_) {}
    }
    const root = button.closest('.dl'), slot = (root?.__dlGetActive?.() ?? 0) + 1;
    if (button.matches('a[href="#make"],a[href^="#DL-"]')) track('create_bundle_clicked');
    if (root && button.matches('[data-slot]') && button.getAttribute('aria-disabled') !== 'true' && !button.classList.contains('dl-locked')) track('drop_started', { slot: Number(button.dataset.slot) });
    if (root && button.matches('[data-hat-choice]')) track('hat_selected', { hat: button.dataset.hatChoice });
    if (root && button.matches('.dl-guide-save')) {
      track('save_drop_clicked', { slot });
      setTimeout(() => { if (root.dataset[`dlSaved${slot}`] !== '1') track('save_drop_error', { slot, reason: 'state_not_saved' }); }, 500);
    }
    if (button.matches('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]')) track('checkout_clicked');
  }, true);
  window.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches?.('.dl [data-upload]') || !input.files?.length) return;
    const root = input.closest('.dl');
    track('upload_started', { slot: (root.__dlGetActive?.() ?? 0) + 1 });
  }, true);
  window.addEventListener('droplit:image-selected', event => {
    const d = event.detail || {};
    if (d.normalized) return;
    const root = d.root || document.querySelector('.dl');
    saved.get(root)?.delete(Number(d.slot));
    if (d.cropped || d.bgRemoved) return;
    if (d.source === 'upload') {
      const preview = root?.querySelector('[data-preview]');
      if (preview) {
        const src = preview.getAttribute('src');
        const done = () => { cleanup(); if (preview.getAttribute('src') === src) track('image_uploaded', { slot: Number(d.slot), source: 'upload' }); };
        const failed = () => { cleanup(); if (preview.getAttribute('src') === src) track('upload_error', { slot: Number(d.slot), reason: 'decode_failed' }); };
        const cleanup = () => { preview.removeEventListener('load', done); preview.removeEventListener('error', failed); };
        if (preview.complete && preview.naturalWidth > 0) done();
        else { preview.addEventListener('load', done, { once: true }); preview.addEventListener('error', failed, { once: true }); }
      }
    }
    if (d.source === 'library') track('library_image_selected', { slot: Number(d.slot), source: 'library' });
  });
  const refreshConsent = () => {
    if (!allowed()) { pending = []; attribution = undefined; try { sessionStorage.removeItem(key); } catch (_) {} }
    clarityConsent();
    boot();
  };
  document.addEventListener('visitorConsentCollected', refreshConsent);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', refreshConsent);
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  let attempts = 0;
  const timer = setInterval(() => {
    if (allowed()) { boot(); pending = pending.filter(entry => !publish(entry)); }
    if (++attempts >= 30) clearInterval(timer);
  }, 1000);
  try {
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => refreshConsent());
  } catch (_) {}
})();

